import {beginAjaxCall, endAjaxCall} from "./ajaxStatusActions";

export const ajaxCallWrapper = (dispatch, call) => {
    dispatch(beginAjaxCall());
    return call.finally(() => {
        dispatch(endAjaxCall());
    });
};
